import { ReactRenderer } from "@tiptap/react";
import tippy, { type Instance } from "tippy.js";
import MentionList from "./MentionList";
import { SuggestionOptions } from "@tiptap/suggestion";

const activePopups = new Set<Instance>();

// Ancestors using `capture: true` on document (e.g. Radix Dialog's
// useEscapeKeydown) would otherwise swallow Escape before the editor sees it,
// closing the drawer instead of the mention popup. Registering at module load
// means this runs before any component-effect-based listener.
if (typeof document !== "undefined") {
  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key !== "Escape") return;
      const visible = Array.from(activePopups).find((p) => p.state.isVisible);
      if (!visible) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      visible.hide();
    },
    { capture: true }
  );
}

const suggestion: Partial<SuggestionOptions> = {
  render: () => {
    let component: ReactRenderer<any, any>;
    let popup: Instance[];

    return {
      onStart: (props) => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }
        // @ts-ignore
        popup = tippy("body", {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start",
          onDestroy: (instance) => activePopups.delete(instance),
        });
        activePopups.add(popup[0]);
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          // @ts-ignore
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === "Escape") {
          if (!popup?.[0]?.state.isVisible) return false;
          popup[0].hide();
          return true;
        }

        return component.ref?.onKeyDown(props);
      },

      onExit() {
        popup?.[0]?.destroy();
        component.destroy();
      },
    };
  },
  allow: (props) => {
    // @ts-ignore
    const items = props.editor.options.editorProps.suggestionItems;
    return items && items.length > 0;
  },
  char: "/",
};

export default suggestion;
